<template>
  <div class="custom-embed-form">
    <select v-model="defKey" name="defKey" v-on:change="onChangeTemplate">
      <option v-for="def in defs" :key="def.key" :value="def.key">{{ def.name }}</option>
    </select>
    <label for="embed_name">Name</label>
    <input type="text" id="embed_name" v-model="title" v-on:blur="updateField('title', $event)" />
    <label for="embed_url">URL</label>
    <input type="text" id="embed_url" v-model="URL" v-on:blur="updateField('URL', $event)" />
    <ul>
      <li v-for="(option, index) in options" :key="'option-' + index">
        <label :for="'embed_option_key' + index">{{ option.label }}</label>
        <input v-if="option.type === 'title'" :id="'embed_option_value' + index" type="text" v-model="option.value" v-on:blur="updateOptionProperty(index, 'value', option.value)" />
        <textarea v-if="option.type === 'text'" :id="'embed_option_value' + index" v-model="option.value" v-on:blur="updateOptionProperty(index, 'value', option.value)" />
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "custom-embed-form",
  props: ["tag"],
  created() {
    console.log("custom embed form created", this.tag);
    this.initTag()
  },
  data() {
    return {
      title: null,
      URL: null,
      payload: null,
      template: null,
      options: [],
      defs: []
    };
  },
  components: {},
  computed: {
    ...mapState(["selection"]),
    ...mapGetters(["currentTime", 'user'])
  },
  watch: {
    'tag': 'onTagChange'
  },
  methods: {
    ...mapMutations(["updateEmbed", "setPlayerTime"]),
    onTagChange(newVal, oldVal) {
      console.log("onTagChange", newVal, oldVal)
      this.initTag()
    },
    initTag() {
      this.title = this.tag.meta.title;
      this.URL = this.tag.meta.URL;
      this.defKey = this.tag.meta.defKey;
      this.payload = this.tag.payload || [];
      this.prepareOptions(this.defKey);
    },
    prepareOptions(defKey) {
      console.log("prepareOptions");
      var defs = []
      const definition = this.user.customComponents;
      Object.keys(definition).forEach(function(key) {
          console.log(key, definition[key]);
          var def = definition[key]
          defs.push({
            key: key,
            name: def.name
          })
      });
      this.defs = defs
      defKey = defKey || defs[0].key
      this.defKey = defKey
      this.options = []
      let d = definition[defKey]
      if (d) {
        definition[defKey].props.forEach(val => {
          var value = this.getValueFor(val.key);
          val.value = value;
          this.options.push(val);
        });
        // take url from set url or fallbackto preset URL
        this.URL = this.URL && this.URL.length > 0 ? this.URL : definition[defKey].url;
        console.log("options", this.options);
      }
    },
    getValueFor(key) {
      var found = this.payload.find(value => {
        return value.key === key;
      });
      return found ? found.value : null;
    },
    updateField(field, eventOrValue) {
      this[field] = eventOrValue.target
        ? eventOrValue.target.value
        : eventOrValue;
      this.updateTagEmbed();
    },
    updateOptionProperty(index, prop, value) {
      console.log("updateOptionProperty", index, prop, value);
      // this.payload[index][prop] = value
      this.updateTagEmbed();
    },
    updateTagEmbed() {
      const { title, URL, defKey, payload, options } = this;
      console.log("updateTagEmbed", title, payload);
      // todo mutation
      this.updateEmbed({ title, URL, defKey, payload: options });
    },
    deleteOption(i) {
      this.payload.splice(i, 1);
      this.updateTagEmbed();
    },
    onNewOption() {
      this.payload.push({
        key: "key",
        value: "value"
      });
    },
    onChangeTemplate() {
      this.prepareOptions(this.defKey);
    }
  }
};
</script>
